import { NavLink, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Package, Users, UserCog, Wallet, LogOut, Building2 } from 'lucide-react';
import Logo from './Logo';
import { isAdmin } from '../utils/auth';

function Sidebar() {
  const navigate = useNavigate();

  const navItems = [
    { to: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
    { to: '/loads', label: 'Loads', icon: Package },
    { to: '/clients', label: 'Clients', icon: Building2 },
    { to: '/drivers', label: 'Drivers', icon: Users },
    ...(isAdmin() ? [{ to: '/dispatchers', label: 'Dispatchers', icon: UserCog }] : []),
    { to: '/payments', label: 'Payments', icon: Wallet },
  ];

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  return (
    <aside style={styles.sidebar}>
      <div style={styles.logoRow}>
        <Logo size={36} variant="blue-bg" />
        <span style={styles.appName}>Hauler Admin</span>
      </div>

      <nav style={styles.nav}>
        {navItems.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            style={({ isActive }) => ({
              ...styles.navItem,
              backgroundColor: isActive ? '#eff6ff' : 'transparent',
              color: isActive ? '#2563eb' : '#374151',
              fontWeight: isActive ? 700 : 500,
            })}
          >
            <Icon size={18} style={{ marginRight: 10 }} />
            {label}
          </NavLink>
        ))}
      </nav>

      {/* Pushed to the bottom of the sidebar via marginTop: auto on the wrapper */}
      <div style={styles.logoutWrapper}>
        <button onClick={handleLogout} style={styles.logoutBtn}>
          <LogOut size={18} style={{ marginRight: 10 }} />
          Logout
        </button>
      </div>
    </aside>
  );
}

const styles = {
  sidebar: {
    width: 220,
    height: '100vh',
    position: 'sticky',
    top: 0,
    backgroundColor: 'white',
    borderRight: '1px solid #e5e7eb',
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    overflowY: 'auto',
  },
  logoRow: {
    display: 'flex',
    alignItems: 'center',
    padding: '20px 18px',
    borderBottom: '1px solid #f3f4f6',
  },
  appName: {
    marginLeft: 10,
    fontWeight: 700,
    fontSize: 15,
    color: '#111827',
  },
  nav: {
    display: 'flex',
    flexDirection: 'column',
    padding: 12,
    gap: 4,
  },
  navItem: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px 12px',
    borderRadius: 8,
    fontSize: 14,
    textDecoration: 'none',
  },
  logoutWrapper: {
    marginTop: 'auto',
    padding: 12,
    borderTop: '1px solid #f3f4f6',
  },
  logoutBtn: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: '10px 12px',
    borderRadius: 8,
    border: 'none',
    backgroundColor: 'transparent',
    color: '#dc2626',
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
  },
};

export default Sidebar;